<template>
<div id="asigmentsEvaluations">
  <h6 class="title-section">Assignments & Evaluations</h6>
  <b-tabs class="calendar">

      <!-- <b-tabs id="tabEvaluations"> -->
        <b-tab :title="$t('title.8')" active>
          <h6>Pending Review</h6>
          <b-table hover :items="items" :show-empty="true" :empty-text="$t('reusables.empty-text')"></b-table>
        </b-tab>
        <b-tab :title="$t('title.9')">
            <b-card-text>Tab contents 2</b-card-text>
        </b-tab>
      <!-- </b-tabs> -->
  </b-tabs>
</div>
</template>
<script>
  export default {
    data() {
      return {
        items: [
          { Student: 'Albert Ramirez', Course: 'Advanced Communication:B1', Folder: 'Module 15',Fildes :'1 submision,1 file',Data_Submited:'Sep 2,2021 8:32Am',Review:'[Icono]'},
          { Student: 'Albert Ramirez', Course: 'Advanced Communication:B1', Folder: 'Module 15',Fildes :'1 submision,1 file',Data_Submited:'Sep 2,2021 8:32Am',Review:'[Icono]'},
          { Student: 'Albert Ramirez', Course: 'Advanced Communication:B1', Folder: '-',Fildes :'1 submision,1 file',Data_Submited:'Sep 2,2021 8:32Am',Review:'[Icono]' },
          { Student: 'Albert Ramirez', Course: 'Advanced Communication:B1', Folder: 'Module 15',Fildes :'1 submision,1 file',Data_Submited:'Sep 2,2021 8:32Am',Review:'[Icono]'}
        ]
      }
    }
  }
</script>